document.addEventListener("click", function (e) {
  const removeBtn = e.target.closest(".custom-cart-remove");

  if (!removeBtn) return;

  e.preventDefault();

  const key = removeBtn.dataset.key;

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: key,
      quantity: 0,
    }),
  };

  const requestPromise =
    typeof window.__BY_prepareCartRemovalRequest === "function"
      ? window.__BY_prepareCartRemovalRequest("/cart/change.js", requestOptions)
      : Promise.resolve({ url: "/cart/change.js", options: requestOptions });

  requestPromise
    .then((request) => fetch(request.url, request.options))
    .then(() => location.reload())
    .catch((error) => {
      console.error("Unable to remove cart item", error);
      location.href = removeBtn.href;
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll("[data-recs-carousel]");

  carousels.forEach((carousel) => {
    const trackWrap = carousel.querySelector(".premium-recs-track-wrap");
    const track = carousel.querySelector("[data-recs-track]");
    const thumb = carousel.querySelector("[data-recs-progress]");

    if (!trackWrap || !track || !thumb) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    function updateProgress() {
      const maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll <= 0) {
        thumb.style.width = "100%";
        return;
      }

      const progressRatio = track.scrollLeft / maxScroll;
      const fillWidth = progressRatio * 100;

      thumb.style.width = `${fillWidth}%`;
    }

    updateProgress();

    track.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);

    trackWrap.addEventListener("mousedown", function (e) {
      isDown = true;
      trackWrap.classList.add("is-dragging");
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
    });

    window.addEventListener("mouseup", function () {
      isDown = false;
      trackWrap.classList.remove("is-dragging");
    });

    trackWrap.addEventListener("mouseleave", function () {
      isDown = false;
      trackWrap.classList.remove("is-dragging");
    });

    trackWrap.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();

      const distance = e.pageX - startX;
      track.scrollLeft = startScrollLeft - distance * 1.2;
    });

    let touchStartX = 0;
    let touchStartScrollLeft = 0;

    trackWrap.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartScrollLeft = track.scrollLeft;
      },
      { passive: true },
    );

    trackWrap.addEventListener(
      "touchmove",
      function (e) {
        const distance = e.touches[0].clientX - touchStartX;
        track.scrollLeft = touchStartScrollLeft - distance * 1.2;
      },
      { passive: true },
    );
  });
});
